import { usePushNotificationRegistration } from '../hooks/usePushNotificationRegistration';

/**
 * MOB-06 — composant INVISIBLE (rend `null`) dont le seul rôle est d'appeler
 * `usePushNotificationRegistration()` À L'INTÉRIEUR de `<AuthProvider>` (le
 * hook consomme `useAuth()`, qui exige ce contexte) — monté UNE SEULE FOIS
 * dans `App.tsx`, comme `<Sidebar />`, jamais démonté/remonté par la
 * navigation.
 */
export function PushNotificationRegistration(): null {
  usePushNotificationRegistration();
  return null;
}
